module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "multicalculo row"
  }, [(_vm.tokenIntegration) ? _c('input', {
    attrs: {
      "type": "hidden",
      "id": "token",
      "name": "token"
    },
    domProps: {
      "value": _vm.tokenIntegration
    }
  }) : _vm._e(), _vm._v(" "), _c('PropostaLoading'), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 no-padding"
  }, [_c('form', {
    ref: "formQuotation"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "faye_channel"
    },
    domProps: {
      "value": _vm.faye.channel
    }
  }), _vm._v(" "), _c('div', {
    class: {
      'form-centered': _vm.centeredForm
    },
    attrs: {
      "id": "quotation-data"
    }
  }, [_c('FormPartialQuotation', {
    attrs: {
      "dataQuotation": _vm.quotation.data
    }
  }), _vm._v(" "), _c('FormPartialRenovation', {
    attrs: {
      "renewal": _vm.quotation.data.renewal
    }
  }), _vm._v(" "), _c('FormPartialCustomer', {
    attrs: {
      "customer": _vm.quotation.data.customer
    }
  }), _vm._v(" "), _c('FormPartialEnterprise', {
    attrs: {
      "residence": _vm.quotation.data.residence
    }
  }), _vm._v(" "), _c('FormPartialQuestionnaire', {
    attrs: {
      "questionnaire": _vm.quotation.data.questionnaire
    }
  }), _vm._v(" "), (!_vm.showFormCustomer) ? _c('FormPartialCoverage', {
    attrs: {
      "coverage": _vm.quotation.data.coverage
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.showFormCustomer) ? _c('FormPartialResult', {
    attrs: {
      "insurers": _vm.quotation.config.insurers
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showFormCustomer) ? _c('div', {
    staticClass: "row",
    class: {
      'text-center': _vm.centeredButtonsForm
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "form_customer",
      "value": "true"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "value": "Solicitar cotação",
      "disabled": _vm.disableButtonQuote
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendForm()
      }
    }
  })])]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6217896d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/enterprise/modules/App.vue
// module id = 342
// module chunks = 0